import React, { useEffect, useState } from 'react';
import './App.css';
import { SpinnerDesign } from './style';
import { AlertBar, lightTheme, Spinner } from 'scorer-ui-kit';
import styled, { ThemeProvider } from 'styled-components';
import Sidebar, { SideChildren } from './components/Sidebar';

import axios from 'axios';
import { API_ENDPOINT } from './utils/Constants';
import useLocalStorage from './hooks/useLocalstorage';

import { Route, Switch, useHistory } from 'react-router-dom';
import StopWatch from './pages/0StopWatch';
import GraphView from './pages/1GraphView';
import TasksetView from './pages/2TasksetView';
import OperatorView from './pages/3OperatorView';
import SetupOperators from './pages/setup/10SetupOperators';
import SetupPosearea from './pages/setup/11SetupPosearea';
import SetupBodyarea from './pages/setup/12SetupBodyarea';
import SetupJobs from './pages/setup/13SetupJobs';
import SetupJobsManual from './pages/setup/14SetupJobsManual';
import SetupTasks from './pages/setup/15SetupTasks';
import SetupTasksets from './pages/setup/16SetupTasksets';
import SetupReview from './pages/setup/17SetupReview';

export const routes = [
  '/main-stopwatch',
  '/main-graph-view',
  '/main-taskset-view',
  '/main-operator-view',
  '/',
  '/',
  '/',
  '/',
  '/',
  '/',

  '/setup-operators',
  '/setup-posearea',
  '/setup-bodyarea',
  '/setup-jobs',
  '/setup-jobs-manual',
  '/setup-tasks',
  '/setup-tasksets',
  '/setup-review',
];

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 12%;
`;

const PageLayout = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 100vh;
  margin: 0px;
  height: 1000px;
  background: #eff4f7;
`;

const AlertContainer = styled.div`
  margin-left: 290px;
  width: 350px;
  position: absolute;
`;

export const MenuContext = React.createContext<ContextProps>({
  selectedStep: 0,
  completedStep: 0,
  isEdit: false,
  setSelectedStep: () => { },
  setCompletedStep: () => { },
  setIsEdit: () => { }
});

export const PathContext = React.createContext<any>({
  pathUpdated: false
});

export const SidebarOpenContext = React.createContext<any>({
  open: true,
  setSidebarOpen: () => { }
});

export const ThemeContext = React.createContext<any>({
  newTheme: lightTheme,
  changeTheme: () => { }
});


function App() {
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState<Alert>({ message: '', type: 'error' });

  const [selectedStep, setSelectedStep] = useState<number>();
  const [completedStep, setCompletedStep] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  const [pathUpdated, setPathUpdated] = useState(false);
  const { push } = useHistory();

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [newTheme, changeTheme] = useState(lightTheme);
  const { setFloorPlanStorage } = useLocalStorage();

  useEffect(() => {
    axios.get(API_ENDPOINT + 'getSetup')
      .then((response) => {
        if (response.status === 200) {
          setFloorPlanStorage({...response.data});
          setLoading(false);
          if (response.data.operators.length === 0){
            setSelectedStep(10);
            setCompletedStep(0);
          }else if (response.data.PoseAreas.length === 0){
            setSelectedStep(11);
            setCompletedStep(10);
          }else if (response.data.BodyAreas.length === 0){
            setSelectedStep(12);
            setCompletedStep(11);
          }else if (response.data.jobs.length === 0){
            setSelectedStep(13);
            setCompletedStep(12);
          }else if (response.data.tasks.length === 0 || response.data.tasks[0].jobList.length === 0){
            setSelectedStep(15);
            setCompletedStep(14);
          }else if (response.data.tasksets.length === 0 || response.data.tasksets[0].taskList.length === 0){
            setSelectedStep(16);
            setCompletedStep(15);
          }else{
            setSelectedStep(0);
            setCompletedStep(999);
            setIsEdit(true);
          }
        }
        else{
          setAlert({ message: 'api接続失敗!', type: 'error' });
        }
      })
      .catch((error) => {
        setAlert({ message: 'api接続失敗!'+error.message, type: 'error' });
      });
  }, [setFloorPlanStorage, setSelectedStep, setCompletedStep, setIsEdit]);

  /*---------route---------*/
  useEffect(() => {
    if (loading) return;
    setFloorPlanStorage({ completed_step: completedStep });
  }, [loading, completedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (loading) return;
    setFloorPlanStorage({ selected_step: selectedStep });
    setPathUpdated(true);
  }, [loading, selectedStep, setFloorPlanStorage]);

  useEffect(() => {
    if (loading) return;
    if (window.location.pathname === routes[selectedStep]) return;
    push(routes[selectedStep]);
  }, [loading, selectedStep, push]);
  /*---------route---------*/

  return (
    <ThemeContext.Provider value={{ newTheme, changeTheme }}>
      <ThemeProvider theme={newTheme}>
        <PageLayout>
          <SidebarOpenContext.Provider value={{ sidebarOpen, setSidebarOpen }}>
            {alert.message !== '' &&
              <AlertContainer>
                <AlertBar type={alert.type} message={alert.message} />
              </AlertContainer>}
            {loading ?
              <SpinnerWrapper>
                <Spinner size='large' styling={SpinnerDesign} />
              </SpinnerWrapper>
              :
              <MenuContext.Provider value={{ selectedStep, completedStep, isEdit, setSelectedStep, setCompletedStep, setIsEdit }}>
                <Sidebar>
                  <SideChildren />
                </Sidebar>
                <Switch>
                  <PathContext.Provider value={{ pathUpdated }}>
                    <Route path='/main-stopwatch' exact component={StopWatch} />
                    <Route path='/main-graph-view' exact component={GraphView} />
                    <Route path='/main-taskset-view' exact component={TasksetView} />
                    <Route path='/main-operator-view' exact component={OperatorView} />
                    <Route path='/' />
                    <Route path='/' />
                    <Route path='/' />
                    <Route path='/' />
                    <Route path='/' />
                    <Route path='/' />

                    <Route path='/setup-operators' exact component={SetupOperators} />
                    <Route path='/setup-posearea' exact component={SetupPosearea} />
                    <Route path='/setup-bodyarea' exact component={SetupBodyarea} />
                    <Route path='/setup-jobs' exact component={SetupJobs} />
                    <Route path='/setup-jobs-manual' exact component={SetupJobsManual} />
                    <Route path='/setup-tasks' exact component={SetupTasks} />
                    <Route path='/setup-tasksets' exact component={SetupTasksets} />
                    <Route path='/setup-review' exact component={SetupReview} />
                  </PathContext.Provider>
                </Switch>
              </MenuContext.Provider>}
          </SidebarOpenContext.Provider>
        </PageLayout>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default App;
